import type { Action } from "../../actions/types";

export type StoreState = {
  data: {
    // tslint:disable-next-line:no-any
    [props: string]: any;
    __editMode__?: boolean;
  };
  // tslint:disable-next-line:no-any
  [props: string]: any;
};

export const initialState = {
  data: {},
};

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  switch (action.type) {
    case "SET_WIDGET_CONFIG":
      return action.data;
    default:
      return state;
  }
}
